import React, { useEffect, useState } from "react";

import { connect, useDispatch, useSelector } from "react-redux";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";

import { CLOSE_BROADCASTGAME_DIALOG } from "../../store/BroadcastGame/types";

import $ from "jquery";
import noImage from "../../assets/images/noImage.png";
import {
  createNewBroadcastGame,
  editBroadcastGame,
} from "../../store/BroadcastGame/action";
import { baseURL } from "../../util/Config";

const BroadcastGameDialog = (props) => {
  const dispatch = useDispatch();

  const { dialog: open, dialogData } = useSelector(
    (state) => state.broadcastgame
  );

  const [mongoId, setMongoId] = useState("");
  const [link, setLink] = useState("");
  const [imageData, setImageData] = useState(null);
  const [imagePath, setImagePath] = useState(null);

  const [errors, setError] = useState({
    link: "",
    image: "",
  });

  $(document).ready(function () {
    $("img").bind("error", function () {
      $(this).attr("src", noImage);
    });
  });

  useEffect(() => {
    if (dialogData) {
      setMongoId(dialogData._id);
      setLink(dialogData.redirectUrl);
      setImagePath(baseURL + dialogData.imageUrl);
    }
  }, [dialogData]);

  useEffect(
    () => () => {
      setError({
        link: "",
        image: "",
      });
      setMongoId("");
      setLink("");
      setImageData(null);
      setImagePath(null);
    },
    [open]
  );

  useEffect(() => {
    window.onbeforeunload = closePopup();
  }, []);

  const HandleInputImage = (e) => {
    setError({ image: "" });
    if (e.target.files[0]) {
      setImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const closePopup = () => {
    dispatch({ type: CLOSE_BROADCASTGAME_DIALOG });
  };

  const isValidURL = (url) => {
    if (typeof url !== "string") return false;
    const urlRegex = /^(ftp|http|https):\/[^ "]+$/;
    return urlRegex.test(url) || url?.startsWith("blob:");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if ( (!mongoId ? !imageData : !imagePath)) {
      const errs = {};
      if (!isValidURL(link)) {
        errs.link = "Enter Valid Link should be start http:// or https://";
      }
      if (!mongoId) {
        if (!imageData || !imagePath) {
          errs.image = "Broadcast Game Photo is Required!";
        } else {
          errs.image = "";
        }
      }
      return setError({ ...errs });
    }

    const formData = new FormData();
    formData.append("imageUrl", imageData);
    formData.append("redirectUrl", link);
    formData.append("bannerType", 2);
    formData.append("bannerId", mongoId);

    if (mongoId) {
      props.editBroadcastGame(mongoId, formData);
    } else {
      props.createNewBroadcastGame(formData);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">
          <span className="text-danger font-weight-bold h4"> Broadcast Game </span>
        </DialogTitle>

        <IconButton style={{ position: "absolute", right: 0 }}>
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>

        <DialogContent>
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="d-flex flex-column">
              <form>
                <div className="form-group">
                  <label className="mb-2 text-gray">Link</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="https://www.google.com"
                    value={link}
                    onChange={(e) => {
                      setLink(e.target.value);
                      if (!e.target.value) {
                        return;
                      } else {
                      }
                    }}
                  />
                  {errors.link && (
                    <div className="ml-2 mt-1">
                      <div className="pl-1 text__left">
                        <span className="text-red">{errors.link}</span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="form-group mt-4">
                  <label className="mb-2 text-gray">Broadcast Game Image</label>
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    accept="image/jpg ,image/jpeg ,image/png"
                    required=""
                    onChange={HandleInputImage}
                  />
                  {errors.image && (
                    <div className="ml-2 mt-1">
                      <div className="pl-1 text__left">
                        <span className="text-red">{errors.image}</span>
                      </div>
                    </div>
                  )}

                  {imagePath && (
                    <img
                      height="70px"
                      width="70px"
                      alt="broadcastgame"
                      src={imagePath}
                      style={{
                        boxShadow: "0 5px 15px 0 rgb(105 103 103 / 0%)",
                        borderRadius: 10,
                        marginTop: 10,
                        float: "left",
                        objectFit: "cover",
                      }}
                    />
                  )}
                </div>

                <div className={imagePath ? "mt-5 pt-5" : "mt-5"}>
                  <button
                    type="button"
                    className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                    onClick={closePopup}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-round float__right btn-danger"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, {
  createNewBroadcastGame,
  editBroadcastGame,
})(BroadcastGameDialog);
